
import { BaseBackgroundEffect } from '@/render/background/BaseBackgroundEffect';
import { BackgroundContext } from '@/render/background/BackgroundEffect';

export class SolidBackground extends BaseBackgroundEffect {
    public render(bc: BackgroundContext): void {
        const { ctx, width, height } = bc;
        ctx.fillStyle = this.getPrimaryColor(bc);
        ctx.fillRect(0, 0, width, height);
    }
}
